import React, { useMemo, useState } from "react";
import { useLocation } from "react-router";
import styled from "styled-components";
import UploadFile from "components/UploadFile";
import { Ptag, OverlayLoader, LargeButton, MainBody } from "components/core";
import config from "../../../config.json";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import routes from "components/routes";
import { Divider } from "@mui/material";
import backarrow from "assets/images/arrowBack.png";
import { LocalHeader } from "pages/UniversalSetup/UniversalCorporateBuffer/updateCorporateBuffer";

const CashDepositUpdate = () => {
  const { state } = useLocation();
  const company_name = localStorage.getItem("company_name");
  const [loading, setLoading] = useState(false);
  const [documentId, setDocumentId] = useState("");
  const [fileData, setFileData] = useState("");
  const [required, setRequired] = useState("");
  const [fileDataRequired, setFileDataRequired] = useState("");
  const [uploadErrorData, setUploadErrorData] = useState([]);
  const navigate = useNavigate();
  const showSidebar = () => {
    return !!localStorage.getItem("id");
  };
  console.log(state);
  const handleSubmit = async () => {
    if (!documentId || !fileData) {
      if (!documentId) {
        setRequired("*required");
      }
      //file data should no be required
      // if (!fileData) {
      //   setFileDataRequired("*required");
      // }
      // return;
    }
    setLoading(true);
    let formData = new FormData();
    formData.append("file_details", fileData);
    formData.append("service_provider_id", state.keyPlanId || undefined);
    formData.append("document_id", documentId);
    try {
      const { data2 } = await axios({
        url: config.apiUrl + "business/update_cd_balance/",
        method: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });

      navigateToNextPage();
    } catch (ex) {
      if (ex.response && Array.isArray(ex.response.data)) {
        setUploadErrorData(
          (ex.response &&
            Array.isArray(ex.response.data) &&
            ex.response.data) ||
            []
        );
      } else {
        alert(ex.response.data);
      }
      setLoading(false);
    }
  };
  const navigateToNextPage = () => {
    navigate("/v1/cash-deposit/");
  };
  const productInitial = useMemo(() => {
    return state?.originalData?.service_provider_name;
  }, [state?.originalData]);

  return (
    <section style={{
      maxWidth: "1000px"
    }}>
      <Ptag
        fontSize="20px"
        fontWeight="500"
        letterHeight="1.33"
        letterSpacing="0.35px"
      >
        {` Update CD Balance for ${productInitial}`}
      </Ptag>
      <UploadFile
        label={`From Insurer`}
        text="Upload File"
        format="pdfXl"
        type="cd_balance_statement"
        onSelect={setDocumentId}
        showError={required}
      />
      <Divider sx={{ mt: 2 }} />
      <UploadFile
        label={`Update Excel File (optional)`}
        text="Upload Excel"
        format="excel"
        type="cd_balance_statement"
        sampleFile="CdLedger"
        fileDataNeed={setFileData}
        onSelect={setFileData}
        // showError={fileDataRequired}
      />
      {!!uploadErrorData.length && (
        <ErrorTag>
          <Ptag
            color="#F27576"
            style={{
              paddingBottom: "12px",
              height: "19px",
              fontSize: "14px",
              fontWeight: "700",
            }}
          >
            Errors!
          </Ptag>
          <div>
            <table
              border="0.4px"
              frame="void"
              rules="all"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <TableData>
                    <Ptag
                      style={{
                        height: "10px",
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      ROW
                    </Ptag>
                  </TableData>
                  <TableData>
                    <Ptag
                      style={{
                        height: "10px",
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      COLUMN
                    </Ptag>
                  </TableData>
                  <TableData>
                    <Ptag
                      style={{
                        paddingLeft: "3px",
                        width: "24px",
                        height: "14px",
                        fontWeight: "600",
                      }}
                    >
                      MESSAGE
                    </Ptag>
                  </TableData>
                </tr>
              </thead>
              <tbody>
                {uploadErrorData.map((error, index) => (
                  <tr>
                    <TableData>
                      <Ptag
                        textAlign="center"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        {error?.row_number || ""}
                      </Ptag>
                    </TableData>
                    <TableData>
                      <Ptag
                        textAlign="center"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        {error?.column || ""} {"  "}
                      </Ptag>
                    </TableData>
                    <TableData>
                      <Ptag style={{ fontSize: "12px", fontWeight: "600" }}>
                        {error?.error || ""}
                      </Ptag>
                    </TableData>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </ErrorTag>
      )}

      <LargeButton label={"Update"} onClick={handleSubmit}></LargeButton>
    </section>
  );
};
// }

const HomeWrapper = styled.div`
  transition: margin-left 0.2s ease-in;
  padding: 0px 0px 50px 80px;
  max-width: 800px;
  box-sizing: border-box;
  background: #fff;
  /* height:100vh; */
  margin-left: 200px;
`;

const ErrorTag = styled.div`
  padding: 24px;
  background-color: #f8f8f8;
  border-radius: 10px;
  margin-bottom: 10px;
`;

const TableData = styled.td`
  padding: 10px;
`;
const InputFieldWrapper = styled.div`
  display: flex;
  width: 342px;
  border: 1px solid #436ab2;
  border-radius: 6px;
  padding: 5px;
  justify-content: left;
  cursor: pointer;
  height: 50px;
  margin-right: 20px;
  /* & > input{
        display: none;
    }   */
`;

const Input = styled.input`
  border: 0;
  outline: none;
  height: auto;
  width: 100%;
  font-size: medium;
  padding-left: 18px;
`;

const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 4rem;
  position: absolute;
  z-index: 9;
`;

export default CashDepositUpdate;
